<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import Vue from 'vue';
import excel from 'vue-excel-export';
Vue.use(excel)
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Store Items",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Inventory",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Inventory Management",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Item Name",
          sortable: true,
        },
        {
          key: "unit",
          label: "Unit Measure",
          sortable: true,
        },
        {
          key: "amount",
          label: "Buying Price",
          sortable: true,
        },
        {
          key: "user",
          label: "Added By",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        name: "",
        amount: "",
        quantity: 0,
        unit: "",
      },
      deletedata: {
        name: "",
        id: "",
      },
      editdata: {
        name: "",
        amount: "",
        unit: "",
        id: "",
      },
      nameError: "",
      unitError: "",
      modal: "",
    };
  },
  watch: {
      SaveStatus(newValue){
          if(newValue){
              this.resetAddModal();
              this.closeModal(this.modal);
          }
      },
  },
  computed: {
    ...mapGetters("inventory", ["StoreItems", "Units", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.StoreItems ? this.StoreItems.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.StoreItems ? this.StoreItems.length : 1;
  },
  methods: {
    ...mapActions({
      FetchStoreItems: "inventory/fetchStoreItems",
      FetchUnits: "inventory/fetchUnits",
      AddItem: "inventory/addItem",
      EditItem: "inventory/editItem",
      DeleteItem: "inventory/deleteItem",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.StoreItems ? this.StoreItems.length : 1;
      this.currentPage = 1;
    },

    // COMMA SEPERTOR FUNCTION
    thousandSeperater(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    addCommas() {
      this.data.amount = this.thousandSeperater(this.data.amount);
    },
    addCommas1() {
      this.editdata.amount = this.thousandSeperater(this.editdata.amount);
    },

    resetError() {
      this.nameError = "";
      this.unitError = "";
    },

    resetAddModal() {
      this.data.name = "";
      this.data.unit = "";
      this.data.quantity = 0;
      this.data.amount = "";
      this.resetError();
    },

    addItem(modal) {
      if (this.data.name == "") {
        this.nameError = "Item name is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.data.unit == "") {
        this.unitError = "Unit field can't be empty";
        return;
      } else {
        this.unitError = "";
      }
      this.modal = modal;
      this.AddItem(this.data);
    },
    showEditModal(values) {
      this.editdata.id = values.item.id;
      this.editdata.name = values.item.name;
      this.editdata.unit = values.item.unit;
      this.editdata.amount = values.item.amount;
    },
    showDeleteModal(values) {
      this.deletedata.id = values.item.id;
      this.deletedata.name = values.item.name;
    },
    deleteItem(modal) {
      this.modal = modal;
      this.DeleteItem(this.deletedata);
      this.closeModal(modal);
    },
    editItem(modal) {
      if (this.editdata.name == "") {
        this.nameError = "Item name is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.editdata.unit == "") {
        this.unitError = "Unit field can't be empty";
        return;
      } else {
        this.unitError = "";
      }
      this.modal = modal;
      this.EditItem(this.editdata);
    },

    closeModal(modalId) {
      this.resetError();
      this.resetAddModal();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchUnits();
    this.FetchStoreItems();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_fees_settings')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">
                  List of Store Items
                </h3>
              </div>
              <div class="col-3">
                <button
                  v-b-modal.add-modal
                  class="btn btn-sm btn-primary float-end"
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_fees_settings')
                    )
                  "
                >
                  <i class="fa fa-plus"></i> Add New
                </button>
                <export-excel
                      :data   = "StoreItems"
                      name    = "Store Items.xls">
                      <b-btn variant="success" class="btn-sm">
                      <i class="fa fa-download"></i>
                      Excel
                      </b-btn>
                  </export-excel>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="StoreItems ? StoreItems : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(term_field)="data">
                  Term {{ data.item.term }}
                </template>
                <template #cell(resid_field)="data">
                  <span v-if="data.item.residence == 1">Day</span>
                  <span v-if="data.item.residence == 2">Boarding</span>
                  <span v-if="data.item.residence == 3">Day && Boarding</span>
                </template>
                <template #cell(entry_field)="data">
                  <span v-if="data.item.entry == 1">Continuing</span>
                  <span v-if="data.item.entry == 2">New</span>
                  <span v-if="data.item.entry == 3">New && Continuing</span>
                </template>
                <template #cell(amount_field)="data">
                  {{ data ? thousandSeperater(data.item.amount) : "---" }}
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <button
                      class="btn btn-outline-primary btn-sm"
                      v-b-modal.edit-modal
                      @click="showEditModal(data)"
                    >
                      <i class="fa fa-edit"></i> Edit
                    </button>
                    <button
                      class="btn btn-outline-danger btn-sm"
                      v-b-modal.delete-modal
                      @click="showDeleteModal(data)"
                    >
                      <i class="fa fa-trash"></i> Delete
                    </button>
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal
        id="add-modal"
        hide-footer
        @hidden="resetAddModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_fees_settings')
          )
        "
      >
        <template #modal-title> Add New Store Item</template>
        <div class="row">
          <div class="form-group mb-2">
            <label class="col-form-label">Item Name</label>
            <div class="input-group">
              <input
                type="text"
                placeholder="Item Name"
                class="form-control"
                @input="resetError()"
                v-model="data.name"
              />
            </div>
            <div class="text-danger" v-if="nameError">
              <em>{{ unitError }}</em>
            </div>
          </div>
          <div class="form-group mb-2">
            <label class="col-form-label">Item Unit</label>
            <input
              v-model="data.unit"
              class="form-control"
              list="fee"
              placeholder="Enter Unit"
              autocomplete="off"
              @input="resetError()"
            />
            <datalist id="fee">
              <option
                v-for="(unit, v) in Units"
                :data-value="unit.id"
                :key="v"
              >
                {{ unit.name }}
              </option>
            </datalist>
            <div class="text-danger" v-if="unitError">
              <em>{{ unitError }}</em>
            </div>
          </div>
          <div class="form-group mb-2">
            <label class="col-form-label">Buying Price</label>
            <div class="input-group">
              <input
                type="text"
                placeholder="Buying Price for each kg/pc/pair etc"
                class="form-control"
                @input="resetError(), addCommas()"
                v-model="data.amount"
              />
            </div>
          </div>
          <div class="form-group mb-2">
            <label class="col-form-label">Opening Stock/Quantity</label>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                v-model="data.quantity"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('add-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
            @click="addItem('add-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal
        id="edit-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_fees_settings')
          )
        "
      >
        <template #modal-title>
          Edit details for {{ editdata.name }}</template
        >
        <div class="form-group mb-2">
            <label class="col-form-label">Item Name</label>
            <div class="input-group">
              <input
                type="text"
                placeholder="Item Name"
                class="form-control"
                @input="resetError()"
                v-model="editdata.name"
              />
            </div>
            <div class="text-danger" v-if="nameError">
              <em>{{ nameError }}</em>
            </div>
          </div>
          <div class="form-group mb-2">
            <label class="col-form-label">Item Unit</label>
            <input
              v-model="editdata.unit"
              class="form-control"
              list="unit"
              placeholder="Enter Unit"
              autocomplete="off"
              @input="resetError()"
            />
            <datalist id="unit">
              <option
                v-for="(unit, v) in Units"
                :data-value="unit.id"
                :key="v"
              >
                {{ unit.name }}
              </option>
            </datalist>
            <div class="text-danger" v-if="unitError">
              <em>{{ unitError }}</em>
            </div>
          </div>
          <div class="form-group mb-2">
            <label class="col-form-label">Buying Price</label>
            <div class="input-group">
              <input
                type="text"
                placeholder="Buying Price for each kg/pc/pair etc"
                class="form-control"
                @input="resetError(), addCommas1()"
                v-model="editdata.amount"
              />
            </div>
          </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-danger btn-sm"
            data-dismiss="modal"
            @click="closeModal('edit-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            @click="editItem('edit-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes
            <b-spinner
              v-if="SaveStatus"
              variant="primary"
              small
              label="Saving"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete setting starts -->
      <b-modal id="delete-modal" hide-footer>
        <template #modal-title>
          <h4 class="text-danger">
            Delete item {{ deletedata.name }}
          </h4></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Do you want to delete store item {{ deletedata.name }} ? Click Proceed Button to confirm.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            @click="deleteItem('delete-modal')"
          >
            <i class="fa fa-trash"></i> Confirm</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
